/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */








      

jQuery(function() {
  
  
  var current_date = new Date();
  var unavail_dates_string = '12-5-2025,10-5-2025,26-4-2025,20-4-2025,14-2-2025,13-2-2025,26-12-2024,25-12-2024,24-12-2024,23-12-2024,7-1-2025,6-1-2025,5-1-2025,4-1-2025,3-1-2025,2-1-2025,1-1-2025,31-12-2024,30-12-2024,29-12-2024,28-12-2024,27-12-2024,'; 
  var unavail_dates = unavail_dates_string.split(',');
  
  var avail_dates_string = ''; 
  var avail_dates = avail_dates_string.split(',');
  runDatePicker();
  
  $("#sidebar-cart").on("focusin", function(){
  	runDatePicker();
  });
  function runDatePicker(){
  
  jQuery("#date").datepicker( { 
    minDate: 0, 
    maxDate: '+6M',
    beforeShowDay: function(date){ 
      var day = date.getDay(); 
      var duummy_date = date;
      var isAvail = false;
      dmy = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();
      
      if (jQuery.inArray(dmy, unavail_dates) != -1) {
        isAvail = false;
      } else {
        if(day == 1 || day == 2 || day == 3 || day == 4 || day == 5 || day == 6){
          if(new Date().setHours(0,0,0,0) == duummy_date.setHours(0,0,0,0)) {
            isAvail = false;
            if(day == 6){ // 10am
              if(parseFloat(new Date().getHours()+'.'+new Date().getMinutes()) < parseFloat("10")){
                isAvail = true;
              }
            }else{ // 2pm
              if(parseFloat(new Date().getHours()+'.'+new Date().getMinutes()) < parseFloat("13")){
                isAvail = true;
              }
            }
          }else{
            isAvail = true;
          }
        }
      }
      if(jQuery.inArray(dmy, avail_dates) != -1) {
      	
          if(new Date().setHours(0,0,0,0) == duummy_date.setHours(0,0,0,0)) {
            isAvail = false;
            if(parseFloat(new Date().getHours()+'.'+new Date().getMinutes()) < parseFloat("10")){
              isAvail = true;
            }
          }else{
            isAvail = true;
          }
        
      }
      return [isAvail,"available","Available"];
    },
    dateFormat: "DD, MM d, yy",
    altFormat: "dd-mm-yy",
    });
               
  }             
              
  jQuery('#date').keydown(function (e) { 
      runDatePicker();        
              
      // Allow: backspace, delete, tab
      if ($.inArray(e.keyCode, [46, 8, 9]) !== -1 ||
      // Allow: Ctrl+A, Command+A
              (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
              (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode > 1 || e.keyCode < 200))) {
          e.preventDefault();
      }
  });               

  
  jQuery(document).on('submit','.custom-cart-form',function(e){
    var cart_note = jQuery('.Cart__Note').length;
    var cart_note_val = jQuery('.Cart__Note').val();
    var date_val = jQuery('#date').val();
    var cart_particulars_val = jQuery('#cart_particulars').val(); 
    var is_date_required = false;
    if(jQuery('#date').hasClass('required')){
    	is_date_required = true;
    }
    
    if((jQuery('#date').val() || is_date_required == false) && (cart_note && jQuery('.Cart__Note').val())){
      fetch(window.routes.cartUrl + '/update.js', {
          body: JSON.stringify({
            attributes: {
              delivery_date: jQuery('#date').val(),
              cart_particulars: jQuery('#cart_particulars').val()
            }
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        });
    }else{
      e.preventDefault();
      if(!jQuery('#date').val() && is_date_required){
        jQuery('#date').css('border','2px solid red');
      }else{
        jQuery('#date').css('border','1px solid #e7e7e7');
      }
      if(!jQuery('.Cart__Note').val() && cart_note){
        if(jQuery('.Cart__OffscreenNoteContainer').attr('aria-hidden') == "true"){ 
          jQuery('button.Cart__NoteButton').css('color','red');
          jQuery('.Cart__Note').css('border','2px solid red');
        }
        jQuery('.Cart__Note').css('border','2px solid red');
      }else{
        jQuery('button.Cart__NoteButton').css('color','inherit');
        jQuery('.Cart__Note').css('border','1px solid #e7e7e7');
      }
      alert("Please fill in the required fields");
    }
  });
  
});      